import { render, staticRenderFns } from "./printCredentialsDeposit.vue?vue&type=template&id=90fcd21e&scoped=true&"
import script from "./printCredentialsDeposit.vue?vue&type=script&lang=js&"
export * from "./printCredentialsDeposit.vue?vue&type=script&lang=js&"
import style0 from "./printCredentialsDeposit.vue?vue&type=style&index=0&id=90fcd21e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fcd21e",
  null
  
)

export default component.exports